

<!-- <mat-dialog-content> -->
  <div class="breadcrumb-wrapper">
    <div class="container">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" [routerLink]="['/home']">{{'HEADER.Home' | translate}}</li>
          <i class="fa fa-angle-right" style="padding: 8px; margin-top: -3px"></i>
          <li class="breadcrumb-item" [routerLink]="['/casestudy']">{{'HEADER.Casestudies' | translate}}
          </li>
        </ol>
      </nav>
    </div>
  </div>
  <div class="wrapper">
    <div class="container">
      <div class="row">
    <h2>Patient Details</h2>
    <div class="col-md-6">
      <table class="table table-bordered">
        <tbody>
          <tr>
            <td>Name</td>
            <td>{{ CaseStudyDetail?.name }}</td>
          </tr>
          <tr>
            <td>Age</td>
            <td>{{ CaseStudyDetail?.age }}</td>
          </tr>
          <tr>
            <td>Date</td>
            <td>{{ CaseStudyDetail?.dateOfDignosis | date }}</td>
          </tr>
          <tr>
            <td>location</td>
            <td>{{ CaseStudyDetail?.location }}</td>
          </tr>
          <tr>
            <td>Diagnosis</td>
            <td>{{ CaseStudyDetail?.dignosis }}</td>
          </tr>
          <tr>
            <td>C/O</td>
            <td>{{ CaseStudyDetail?.co }}</td>
          </tr>
        </tbody>
      </table>
    </div>
      <div class="col-md-6">
      <div class="row" style="font-size: 18px;color: black;">
        Before Treatment
      </div>
      <br />
      <div class="row" style="margin-bottom: 15px;color: black;">
        {{ CaseStudyDetail?.beforeTreatement }}
      </div>

      <div class="row" style="font-size: 18px; color:black">
        After Treatment
      </div>
      <br />
      <div class="row" style="color: black;">
        {{ CaseStudyDetail?.afterTreatement }}
      </div>
    </div>

    </div>
  </div>
  </div>
 <!-- </mat-dialog-content>
<mat-dialog-actions> -->
  <!-- <button class="btn btn-dark " (click)="closeMe()" style="float: right;">Close</button> -->
<!-- </mat-dialog-actions> -->


